import { useMutation, useQuery } from "react-query";
import { filterFetch, normalFetch } from "../../../fetch-api/get";
import { useMainContext } from "../../../../contexts/main";
import { makeQueryFilters } from "../../../../utils/query-maker";
import { useQueryContext } from "../../../../contexts/query";
import { postApi } from "../../../fetch-api/post";


export const useGetAllCards = (filters, pagination, extra, csv) => {

    const { lang } = useMainContext()
    const newFilters = { ...extra, ...filters }
    const params = { ...makeQueryFilters(newFilters, lang), ...pagination }
    if (csv) {
        params.export = 'csv'
    }

    return useQuery(
        "get-all-cards", () => filterFetch(params, 'cards/admin'),
        {
            cacheTime: 0
        }
    )
}

export const useGetACard = (id) => {

    const { lang } = useMainContext()

    return useQuery(
        "get-a-card", () => normalFetch(`cards/admin/${id}`),
        {
            cacheTime: 0,
            enabled: !!id,
            select: res => res?.data?.data
        }
    )
}

export const useGetCardsTransfers = (filters, pagination, extra, csv) => {

    const { lang } = useMainContext()
    const newFilters = { ...extra, ...filters }
    const params = { ...makeQueryFilters(newFilters, lang), ...pagination }
    if (csv) {
        params.export = 'csv'
    }

    return useQuery(
        "get-cards-transfer", () => filterFetch(params, 'cards/admin/transfer'),
        {
            cacheTime: 0
        }
    )
}

export const useGetACardTransfer = (id) => {

    const { lang } = useMainContext()

    return useQuery(
        "get-a-card-transfer", () => normalFetch(`cards/admin/transfer/${id}`),
        {
            cacheTime: 0,
            enabled: !!id,
            select: res => res?.data?.data
        }
    )
}


export const useGetUserBalanceHistory = (filters, pagination, extra, csv) => {

    const { lang } = useMainContext()
    const newFilters = { ...extra, ...filters }
    const params = { ...makeQueryFilters(newFilters, lang), ...pagination }
    if (csv) {
        params.export = 'csv'
    }

    return useQuery(
        ["get-user-balance-history", extra], () => filterFetch({}, `cards/admin/balance/${extra?.userId}/history`),
        {
            cacheTime: 0,
            select: res => res?.data
        }
    )
}

export const useGetUserCardHistory = (filters, pagination, extra, csv) => {

    const { lang } = useMainContext()
    const newFilters = { ...extra, ...filters }
    const params = { ...makeQueryFilters(newFilters, lang), ...pagination }
    if (csv) {
        params.export = 'csv'
    }

    return useQuery(
        ["get-user-card-history", extra], () => filterFetch({}, `cards/admin/balance/card/${extra?.cardId}/history`),
        {
            cacheTime: 0,
            select: res => res?.data
        }
    )
}

export const useGetUserCardBalance = (userId) => {

    const { lang } = useMainContext()


    return useQuery(
        ["get-user-card-balance", userId], () => filterFetch({}, `cards/admin/balance/${userId}`),
        {
            cacheTime: 0,
            select: res => res?.data?.data,
            enabled: !!userId
        }
    )
}

export const useWithdrawUserCardBalance = (onSuccess) => {
    const { setToast, queryClient } = useQueryContext();

    return useMutation(
        'withdraw-user-card-balance',
        (data) => postApi(data?.payload, `cards/admin/balance/${data?.userId}/withdraw`),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('get-user-card-balance')
                onSuccess && onSuccess()
                setToast({
                    show: true,
                    message: 'Balance withdrawn successfully',
                    isError: false,
                })
            },
            onError: (error) => {
                setToast({
                    show: true,
                    message: error?.response?.data?.message || 'Something went wrong',
                    isError: true,
                })

            }
        }
    )
}
